<template>
  <div id="appRoot">
    <error-snackbar></error-snackbar>
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app bg">
        <app-drawer v-if="isWebLogin" class="app--drawer hidden-md-and-up"></app-drawer>
        <app-toolbar v-if="isWebLogin" class="app--toolbar"></app-toolbar>
        <v-content>
          <!-- Page Header -->
          <div>
            <router-view></router-view>
          </div>
        </v-content>
        <!-- App Footer -->
        <v-footer v-if="isWebLogin" class="secondary pa-3 footer">
          <span class="caption">Swen Srl</span>
          <v-spacer></v-spacer>
          <router-link :to="{ path: '/PrivacyPolicy' }">Privacy Policy</router-link>
          <v-spacer></v-spacer>
          <span class="caption">&copy; {{ new Date().getFullYear() }}</span>
        </v-footer>
        <!-- Go to top -->
        <app-fab></app-fab>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-snackbar :value="updateExists" :timeout="0" bottom right color="orange">
      Aggiornamento disponibile
      <v-btn @click="refreshApp" color="success">
        Aggiorna!
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbar.show" :timeout="3000" :color="snackbar.color" bottom right>
      {{ snackbar.text }}
      <v-btn @click.native="snackbar.show = false" dark flat icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
  import update from './mixins/update';
  import AppDrawer from '@/components/AppDrawer';
  import AppToolbar from '@/components/AppToolbar';
  import AppFab from '@/components/AppFab';
  import ErrorSnackbar from '@/components/errors/ErrorSnackbar';
  import AppEvents from './event';
  import { mapGetters, mapActions } from 'vuex';
  export default {
    components: {
      AppDrawer,
      AppToolbar,
      AppFab,
      ErrorSnackbar,
    },
    mixins: [update],
    data: () => ({
      expanded: false,
      snackbar: {
        show: false,
        text: '',
        color: '',
      },
    }),

    computed: {
      ...mapGetters(['userData']),

      isWebLogin() {
        let retVal = false;
        if (this.userData) {
          if (this.userData.tipoAccesso == 'WEB') {
            retVal = true;
          } else {
            retVal = false;
          }
        } else {
          retVal = false;
        }
        return retVal;
      },
    },

    created() {
      AppEvents.forEach((item) => {
        this.$on(item.name, item.callback);
      });
      window.getApp = this;
    },
  };
</script>

<style scoped>
  .footer {
    bottom: 0;
    height: 30px;
  }
</style>
